import {spawnErrorToast, spawnSuccessToast} from '@hm/fundamental'
import {useQueryClient} from '@tanstack/react-query'
import {useTranslation} from 'react-i18next'

import {mutations} from '@refra/api/mutations'
import {useRefraMutation} from '@refra/modules/common/hooks'
import {logger} from '@refra/modules/common/utils'

export const useEditShutdownStatus = () => {
  const {t} = useTranslation()
  const queryClient = useQueryClient()

  return useRefraMutation({
    mutationFn: mutations.editShutdownStatus,
    onError: (error) => {
      const errorDetails = error?.response?.data.detail ?? error.message ?? error.response?.status
      logger
        .context('useEditShutdownStatus')
        .extras({errorDetails})
        .error('Error occurred while editing shutdown status')

      spawnErrorToast(t('error.editShutdownStatus'))
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({queryKey: ['shutdowns']})
      await queryClient.invalidateQueries({queryKey: ['kilnMaterialInstallations']})
      spawnSuccessToast(t('success.editShutdownStatus'))
    }
  })
}
